import { useCallback } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { UPDATE_GROUP_MEMBERS } from './constants'
import { app } from '../../../common/feathers'

const userService = app.service('users')

export function updateGroupMembers (propertyName, members) {
  return {
    type: UPDATE_GROUP_MEMBERS,
    propertyName,
    data: members
  }
}

export function useUpdateGroupMembers (propertyName) {
  const dispatch = useDispatch()
  const boundAction = useCallback(
    (members) => dispatch(updateGroupMembers(propertyName, members)),
    [dispatch, propertyName]
  )

  const { userChecked, info } = useSelector(
    state => ({
      userChecked: state.user.userChecked,
      info: state.user.info
    }),
    shallowEqual
  )

  return { updateGroupMembers: boundAction, userChecked, info }
}

let _timeouts = {} // Track timeouts per property

export function reducer (state, action) {
  switch (action.type) {
    case UPDATE_GROUP_MEMBERS:
      const { propertyName, data } = action

      state.info = {
        ...state.info,
        [propertyName]: data
      }

      if (_timeouts[propertyName]) {
        clearTimeout(_timeouts[propertyName])
      }

      _timeouts[propertyName] = setTimeout(async () => {
        // Fetch fresh user data
        const freshUser = await userService.get(state.info._id)
        const userData = (freshUser && freshUser.data && Array.isArray(freshUser.data))
          ? freshUser.data[0]
          : freshUser
        const latestMembers = userData && userData[propertyName]
          ? userData[propertyName]
          : []

        // Create map for quick lookup
        const freshMembersMap = {}
        latestMembers.forEach(m => {
          if (m._id) freshMembersMap[m._id] = m
        })

        // Merge: preserve verification fields from server
        const mergedMembers = data.map(newMember => {
          const freshMember = freshMembersMap[newMember._id]
          if (freshMember) {
            return {
              ...newMember,
              emailVerified: freshMember.emailVerified !== undefined
                ? freshMember.emailVerified
                : newMember.emailVerified,
              phoneVerified: freshMember.phoneVerified !== undefined
                ? freshMember.phoneVerified
                : newMember.phoneVerified
            }
          }
          return newMember
        })

        userService.emit('patch')
        userService.patch(state.info._id, { [propertyName]: mergedMembers })
      }, 500)

      return { ...state }

    default:
      return state
  }
}
